import cn from 'classnames';
import { FC } from 'react';

import { Layout } from '@/shared/ui';

import { Header } from '@/widgets/Header';

import styles from './SegmentationReport.module.scss';

type ReportProps = {
  className?: string;
};

export const SegmentationReport: FC<ReportProps> = (props) => {
  const { className } = props;

  return (
    <Layout>
      <Layout.Header>
        <Header />
      </Layout.Header>

      <Layout.Content>
        <Layout.Main>
          <Layout.Content
            className={cn(styles.container, className)}
            data-section="segmentation-report"
          >
            <h1>Segmentation Page</h1>
          </Layout.Content>
        </Layout.Main>
      </Layout.Content>
    </Layout>
  );
};
